// Hook for accessing auth context - moved to fix React refresh warnings
import { useContext } from 'react';
import { AuthContext } from './useAuth';

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
};
